module.exports = __webpack_public_path__ + "img/daichao1.3ab17065.png";